import {request} from "./backend_util.ts";

// Raw PR data from server
export interface PRData {
    dateMerged: string;  // ISO date string
    repo: string;
    username: string;
    teamName: string | null;  // Team name from the user's team
    additions: number;
    deletions: number;
    totalLoc: number;           // Total lines changed (additions + deletions)
    aiContribution: string;     // AI contribution category from PR template
    aiLoc: number;              // Calculated AI-contributed LOC based on category
}

export interface LOCResponse {
    data: PRData[];
}

export interface PulseAllocationDataPoint {
    day: string;
    user_id: number;
    allocation: Record<string, number>;
}

export interface PulseAllocationResponse {
    data: PulseAllocationDataPoint[];
}

const metricsBackend = {
    getLOCData: (from: string, to: string, timezone?: string, teamId?: number, department?: string, userId?: number) => {
        const params = new URLSearchParams({ 
            start: from, 
            end: to,
            ...(timezone && { timezone }),
            ...(userId && { userId: userId.toString() }),
            ...(teamId && { teamId: teamId.toString() }),
            ...(department && department !== 'all' && { department })
        });
        return request<LOCResponse>('GET', `/metrics/loc?${params.toString()}`)();
    },
    
    getPulseAllocationData: (from: string, to: string, department?: string, timezone?: string, teamId?: number, userId?: number) => {
        const params = new URLSearchParams({ 
            start: from, 
            end: to
        });
        if (userId) {
            params.append('userId', userId.toString());
        }
        if (department && department !== 'all') {
            params.append('department', department);
        }
        if (timezone) {
            params.append('timezone', timezone);
        }
        if (teamId) {
            params.append('teamId', teamId.toString());
        }
        return request<PulseAllocationResponse>('GET', `/metrics/pulse-allocation?${params.toString()}`)();
    }
};

export default metricsBackend;
